export const CACHE_KEY_LIST_COMMERCIAL_REGISTER = 'commercialRegisters';
export const CACHE_KEY_COMMERCIAL_REGISTER = 'commercialRegister-one';
export const ROUTE_PATH_COMMERCIAL_REGISTER = '/configuration/commercial-registers';
export const TRANSLATION_PREFIX_COMMERCIAL_REGISTER = 'commercialRegister';
export const SECURITY_KEY_COMMERCIAL_REGISTER = 'COMMERCIAL_REGISTER';

